<template>
    <div>
        <v-row class="justify-center" v-if="numPages > 1">
            <v-col cols="12" lg="1" sm="1" xl="1" style="padding: 0;">
                <v-text-field min="1" :max="numPages" v-model.number="page" outlined dense type="number"></v-text-field>
            </v-col>
            <span style="padding-top: 8px; font-size: 20px; padding-left: 10px;"> /{{numPages}}</span>
        </v-row>
        <div>
            <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center;" :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>
            <pdf v-if="show" ref="pdf" :src="src" :page="page" :rotate="rotate" @progress="loadedRatio = $event" @error="error" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
        </div>
    </div>
</template>
<script>
    import pdf from "vue-pdf";

    export default {
        components: {
            pdf: pdf,
        },
        data() {
            return {
                show: true,
                src:'https://wikieducator.org/images/4/41/Logrithm_Table.pdf',
                // src: "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf",
                loadedRatio: 0,
                page: 1,
                numPages: 0,
                rotate: 0,
            };
        },
        methods: {
            password: function (updatePassword, reason) {
                updatePassword(prompt('password is "test"'));
            },
            error: function (err) {
                console.log(err);
            },
        },
    };
</script>
